import { t } from 'i18next';
import * as Yup from 'yup';
export const MAX_NUMBER = 10000000000;
export const MAX_NUMBER_MESSAGE = t('common.validation.lessThan10Billion');

export const MAX_NUMBER_MILLION = 1000000;
export const MAX_NUMBER_MESSAGE_MILLION = 'Less than 10 million';

export const required = (Validator) =>
  Validator.required(() => t('common.validation.required'));
export const moreThanZero = (Validator) =>
  Validator.moreThan(0, t('common.validation.cant_zero'));
export const moreThanMinus = (Validator) =>
  Validator.moreThan(-1, t('common.validation.cant_zero'));

// assumed string
export const wrapValidateMax = (Validator, max) =>
  Validator.max(max, `No more than ${max} characters.`);
export const ValidateAmountNumber = (Validator, maximum) =>
  !isNaN(Validator) &&
  Yup.number().lessThan(maximum + 1, t('common.validation.greaterThanAmount')); //handled the 'nan' value check

export const ValidateRequired = Yup.string()
  .trim()
  .required(() => t('common.validation.required'));

export const ValidateNumber = Yup.number().nullable();

export const ValidateZipCode = Yup.string()
  .max(20, () => t('common.validation.max20'))
  .nullable();

export const ValidateDate = Yup.date().nullable();

export const ValidateName = Yup.string()
  .trim()
  .max(100, () => t('common.validation.max100'));

export const ValidateName45 = Yup.string()
  .trim()
  .max(45, () => t('common.validation.max45'));

export const ValidateUrl = Yup.string().url(() =>
  t('common.validation.invalid_url')
);

export const ValidateEmail = Yup.string()
  .max(100, () => t('common.validation.max100'))
  .email(() => t('common.validation.invalid_email'));

/*export const ValidateContactEmail = Yup.object().shape({
  email: Yup.array()
    .transform(function(value, originalValue) {
      if (this.isType(value) && value !== null) {
        return value;
      }
      return originalValue ? originalValue.split(/[\s,]+/) : [];
    })
    .of(Yup.string().email(({ value }) => `${value} is not a valid email`)),
});*/

export const ValidateContactEmail = Yup.string()
  .max(250, () => t('common.validation.max250'))
  .matches(
    // for regex backup ([\w\055%]*\.?[\w+\055%]+@[A-Za-z0-9-]{2,61}\.[A-Za-z0-9-]{2,61}(\.[A-Za-z0-9-]{2,61})*\,\s?)
    // /^(([\w\055%]*\.?){0,4}[\w+\055%]+@[A-Za-z0-9-]{2,61}\.[A-Za-z0-9-]{2,61}(\.[A-Za-z0-9-]{2,61})*\,\s?)*([\w\055%]*\.?[\w+\055%]+@[A-Za-z0-9-]{1,61}\.[A-Za-z0-9-]{2,61}(\.[A-Za-z0-9-]{2,61})*\s?)$/,
    /* eslint-disable no-useless-escape */
    /^(([\w\055%]*\.?){0,4}[\w+\055%]+@[A-Za-z0-9-]{2,61}\.[A-Za-z0-9-]{2,61}(\.[A-Za-z0-9-]{2,61})*\,\s?)*([\w\055%]*\.?[\w+\055%]+@[A-Za-z0-9-]{1,61}\.[A-Za-z0-9-]{2,61}(\.[A-Za-z0-9-]{2,61})*\s?)$/,
    // /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    () => t('common.validation.invalid_format')
  );

export const ValidatePercentage = Yup.number()
  .moreThan(0, () => t('common.validation.greater_than_0'))
  .max(100, () => t('common.validation.max100equal'))
  .nullable();

export const ValidateItems = Yup.array()
  .of(
    Yup.object().shape({
      name: ValidateRequired,
      quantity: required(moreThanZero(ValidateNumber)),
      unitPrice: required(moreThanZero(ValidateNumber)),
    })
  )
  .min(1, () => t('common.validation.atLeastOneItem'));

export const ValidateMax255 = Yup.string()
  .trim()
  .max(255, () => t('common.validation.max255'));

export const ValidateMax1000 = Yup.string()
  .trim()
  .max(1000, () => t('common.validation.max1000Chars'));

export const ValidateEqual0 = Yup.string().trim();

export const ValidateMax200 = Yup.string()
  .trim()
  .max(200, () => t('common.validation.max200'));

export const ValidateMax240 = Yup.string()
  .trim()
  .max(240, () => t('common.validation.max240'));

export const ValidateMaxOnlyAlpha30 = Yup.string()
  .matches(/^[ A-Z a-z ]+$/, () => t('common.validation.only_alphabets'))
  .trim()
  .max(30, () => t('common.validation.max30'));
export const ValidateMaxOnlyAlpha25 = Yup.string()
  .matches(/^[ A-Z a-z ]+$/, () => t('common.validation.only_alphabets'))
  .trim()
  .max(25, () => t('common.validation.max25'));

export const ValidateMaxOnlyAlpha200 = Yup.string()
  .matches(/^[A-Za-z]+$/, () => t('common.validation.only_alphabets'))
  .trim()
  .max(200, () => t('common.validation.max200'));

export const ValidateMaxOnlyAlphaWithSpace200 = Yup.string()
  .matches(/^[A-Z a-z ]+$/, () => t('common.validation.only_alphabets'))
  .trim()
  .max(200, () => t('common.validation.max200'));

export const ValidateMaxOnlyDigi50 = Yup.string()
  .matches(/^[A-Za-z0-9-]+$/, () => t('common.validation.only_numbers'))
  .trim()
  .max(50, () => t('common.validation.max50'));

export const ValidateMax120 = Yup.string()
  .trim()
  .max(120, () => t('common.validation.max120'));

export const ValidateMax100 = Yup.string()
  .trim()
  .max(100, () => t('common.validation.max100'));

export const ValidateMax20 = Yup.string()
  .trim()
  .max(20, () => t('common.validation.max20'));

export const ValidateMax50 = Yup.string()
  .trim()
  .max(50, () => t('common.validation.max50'));

export const ValidateMax60 = Yup.string()
  .trim()
  .max(60, () => t('common.validation.max60'));

export const ValidateMax55 = Yup.string()
  .trim()
  .max(55, () => t('common.validation.max55'));

export const ValidateMax30 = Yup.string()
  .trim()
  .max(30, () => t('common.validation.max30'));

export const ValidateMax25 = Yup.string()
  .trim()
  .max(25, () => t('common.validation.max25'));

export const ValidateMax6 = Yup.string()
  .trim()
  .max(6, () => t('common.validation.max6'));

export const ValidateMax15 = Yup.string()
  .trim()
  .max(15, () => t('common.validation.max15'));

export const ValidateMax4 = Yup.string()
  .trim()
  .max(4, () => t('common.validation.max4'));

export const ValidatePhoneNumber = Yup.string().test(
  'is-valid',
  () => t('common.validation.invalid_phone_no'),
  (value) => {
    if (!value) return true;
    return !value.includes('_');
  }
);

export const ValidateMobileNumber = Yup.string().test(
  'is-valid',
  () => t('common.validation.invalid_mobile_no'),
  (value) => {
    if (!value) return true;
    return !value.includes('_');
  }
);

export const ValidateFaxNumber = Yup.string().test(
  'is-valid',
  () => t('common.validation.invalid_fax_no'),
  (value) => {
    if (!value) return true;
    return !value.includes('_');
  }
);

export const ValidateMax10Billion = Yup.number()
  .nullable()
  .lessThan(MAX_NUMBER, MAX_NUMBER_MESSAGE);

export const ValidateMax10Million = Yup.number()
  .nullable()
  .lessThan(MAX_NUMBER_MILLION, MAX_NUMBER_MESSAGE_MILLION);

export const ValidateMax10BillionPos = Yup.number()
  .nullable()
  .positive(() => t('common.validation.max4'))
  .lessThan(MAX_NUMBER, MAX_NUMBER_MESSAGE);

export const ValidateMax100Number = Yup.number()
  .nullable()
  .max(100, () => t('common.validation.max100'));

export const ValidateWebsite = Yup.string()
  .matches(
    /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,20}(:[0-9]{1,5})?(\/.*)?$/,
    () => t('common.validation.invalid_url')
  )
  .max(255, () => t('common.validation.max255'));

export const ValidateNumerMoreThenZero = Yup.number()
  .required(() => t('common.validation.required'))
  .moreThan(0, () => t('common.validation.greater_than_0'))
  .nullable();
